import { addDays, endOfDay } from 'date-fns'

// last possible collection / delivery time
export const getLatestFulfilmentTime = (
  daysOfferedInAdvanceMax: number
): Date => endOfDay(addDays(new Date(), daysOfferedInAdvanceMax))
